module.exports = __webpack_public_path__ + "img/anju-applet.f911145c.jpg";